import { render, staticRenderFns } from "./SubGrupoProdutoRoute.vue?vue&type=template&id=53477f42"
import script from "./SubGrupoProdutoRoute.vue?vue&type=script&lang=js"
export * from "./SubGrupoProdutoRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports